import { preview } from '@/components/form/preview'
import { selectTerritories } from '@/features/domain/territory'
import { Link } from '@mui/material'
import { ContentCopy, Edit } from '@workwave-tidal/core/icons'
import { Stack } from 'apps/route-manager/src/scheduler/utils/createSchedulerConfig/features/eventTooltip/components/EventTooltip/components/Stack'
import { useSelector } from 'react-redux'
import { useTexts } from './../useTexts'

interface Props {
  onEdit: () => void
  onCopy: () => void
}

export function Header(props: Props) {
  const texts = useTexts()

  const territories = useSelector(selectTerritories)
  const singleTerritory = Object.keys(territories).length <= 1
  const copyTooltipText = singleTerritory ? texts.oneTerritory : texts.copySettings

  return (
    <preview.Header
      title={texts.title}
      subtitle={
        <Stack spacing={1}>
          {texts.description}
          <Link
            href="https://workwave.my.site.com/routemanager/s/article/Enhanced-Required-Actions-for-Drivers"
            underline="none"
            target="_blank"
          >
            {texts.learnMore}
          </Link>
        </Stack>
      }
      testId="driver-assistance-view-header"
    >
      <preview.ActionBar>
        <preview.ActionBarItem
          icon={<Edit />}
          onClick={props.onEdit}
          label={texts.edit}
          disableWhenReadOnly
          tooltip={texts.edit}
          testId="driver-assistance-view__edit"
          data-trackid="driver-assistance-view__edit"
        />
        <preview.ActionBarItem
          icon={<ContentCopy />}
          onClick={props.onCopy}
          label={texts.copy}
          disableWhenReadOnly
          disabled={singleTerritory}
          tooltip={copyTooltipText}
          testId="driver-assistance-view__copy"
          data-trackid="driver-assistance-view__copy"
        />
      </preview.ActionBar>
    </preview.Header>
  )
}
